exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".custom-select[data-v-25d79b02]{color:#555}", "", {"version":3,"sources":["/builds/nathaphol/aritsurvey/Learning/src/views/home.vue"],"names":[],"mappings":"AACA,gCACE,UAAe,CAChB","file":"home.vue","sourcesContent":["\n.custom-select[data-v-25d79b02] {\n  color: #555555;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25d79b02","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home.vue
// module id = 182
// module chunks = 0